/**
 * Inventory Store
 *
 * @since 2018-04-12
 * @author dev014
 */
export const state = () => ({
  webCategoryM: {
    url: '/api/op/wf/filter/web/categories',
    name_key: 'name'
  },
  webCategoryS: {
    url: '/api/op/wf/filter/web/categories',
    name_key: 'name',
    parent_key: 'upper_cate_id'
  },
  webFilterM: {
    url: '/api/op/wf/filter/categories',
    name_key: 'name'
  },
  webFilterS: {
    url: '/api/op/wf/filter/categories',
    value_key: 'cate_id',
    name_key: 'name',
    parent_key: 'upper_cate_id'
  },
  appProtocol: {
    url: '/api/op/app/protocols',
    name_key: 'app_proto_uname' // TAMS
  },
  app: {
    url: '/api/op/app/simple/objects',
    name_key: 'app_obj_name' // TAMS
  },
  appCategory: {
    url: '/api/op/app/categories',
    name_key: 'app_cate_uname' // TAMS
  },
  protocol: {
    url: '/api/op/service/protocols',
    name_key: 'name',
    value_key: 'prtc_obj_id'
  },
  srcOsId: {
    url: '/api/lr/filter/os',
    name_key: 'name'
    // value_key: 'os_name_id' // 이름만표시
  },
  srcProgramId: {
    url: '/api/lr/filter/program',
    name_key: 'name'
    // value_key: 'prog_name_id' // 이름만표시
  },
  dstOsId: {
    url: '/api/lr/filter/os',
    name_key: 'name'
    // value_key: 'os_name_id' // 이름만표시
  },
  dstProgramId: {
    url: '/api/lr/filter/program',
    name_key: 'name'
    // value_key: 'prog_name_id' // 이름만표시
  },
  urlInfo: {
    type: '', // urlKey
    param: {} // parameter
  },
  filterData: [],
  levelFilterData: {}
})

export const mutations = {
  getWebFilterData (state, data) {
    const info = state[state.urlInfo.type]

    const levelData = {}
    const parentData = []
    _.forEach(data, (d) => {
      // 부모 배열
      parentData.push({'key': d[info.parent_key], 'value': d.name})

      const childData = []
      _.forEach(d.subcategory, (sD) => {
        const val = (info.value_key !== undefined) ? `${sD[info.name_key]}(${sD[info.value_key]})` : sD[info.name_key]
        childData.push({ 'value': val })
      })

      levelData[d[info.parent_key]] = childData
    })

    if (info.parent_key !== undefined) {
      state.levelFilterData = {parent: parentData, levelData: levelData}
    } else {
      state.filterData = parentData
    }
    // } else {
    //   let arr = []
    //   _.forEach(data, (d) => {
    //     let val = (info.value_key !== undefined) ? `${d[info.name_key]}(${d[info.value_key]})` : d[info.name_key]
    //     arr.push({ 'value': val })
    //   })
    //   state.filterData = arr
    // }
  },
  getFilterData (state, data) {
    const filterD = []
    const info = state[state.urlInfo.type]

    _.forEach(data, sD => {
      if (state.urlInfo.type === 'protocol') {
        filterD.push({ 'name': sD[info.name_key], 'value': sD[info.value_key] + '' })
      } else {
        const val = (info.value_key !== undefined) ? `${sD[info.name_key]}(${sD[info.value_key]})` : sD[info.name_key]
        filterD.push({
          value: val,
          appObjId: _.get(sD, 'app_obj_id')
        })
      }
    })
    state.filterData = filterD
  }
}
export const actions = {
  // 로그 검색 진행 상태 조회
  async getFilterData ({commit, state}) {
    let result = {}
    const urlType = state.urlInfo.type
    if (urlType === '') return result
    const apiUrl = state[urlType].url
    try {
      result = await this.$axios.$get(apiUrl, {data: {}})

      if (urlType.indexOf('web') > -1) {
        if (result.code === 'ok') {
          commit('getWebFilterData', result.result)
        } else {
          commit('getWebFilterData', [])
        }
      } else {
        if (result.code === 'ok') {
          commit('getFilterData', result.result)
        } else {
          commit('getFilterData', [])
        }
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      if (urlType.indexOf('web') > -1) {
        commit('getWebFilterData', [])
      } else {
        commit('getFilterData', [])
      }
      return result
    }
  }
}

export const getters = {}
export const strict = false
